const initialState = () => ({
  events: [],
  tasks: [],
  sprints: [],
  loading: false,
  loadingTasks: false,
  fetchAllRequestId: 0,
  recurrence: null,
  // New Calendar
  selectedUsers: [],
  newEvent: {
    title: '',
    summary: null,
    range: false,
    type: null,
    perDay: null,
    allDay: false,
    dates: [],
    time: {
      start: null,
      end: null
    },
    formId: null,
    forms: null,
    locationId: null,
    location: null,
    locations: [],
    role: null,
    sendNotification: false,
    guests: [],
    forOthers: false,
    recurrence: null,
    meetLink: null,
    link: null,
    file: null,
    usersId: []
  }
})

export default initialState
